'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'bug';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f188';
var svgPathData = 'M192 96c0-53 43-96 96-96s96 43 96 96l0 32-192 0 0-32zm364.8 38.4C549.3 140 513.1 167.2 448 216l0 40 128 0 0 64-128 0 0 32c0 2.6-.1 5.3-.2 7.9 65.2 48.9 101.6 76.2 109 81.7l-38.4 51.2c-10.8-8.1-40.4-30.3-88.7-66.5-23.2 44.2-66.5 76.2-117.7 83.9l0-254.2-48 0 0 254.2c-51.2-7.7-94.5-39.7-117.7-83.9-48.3 36.2-77.8 58.4-88.7 66.5L19.2 441.6c7.4-5.6 43.8-32.8 109-81.7-.1-2.6-.2-5.2-.2-7.9l0-32-128 0 0-64 128 0 0-40C62.9 167.2 26.7 140 19.2 134.4L57.6 83.2c5 3.7 46.2 34.7 123.7 92.8l213.3 0c77.5-58.1 118.8-89.1 123.7-92.8l38.4 51.2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBug = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;